import { render, staticRenderFns } from "./myCustomerReport.vue?vue&type=template&id=24f12c63&"
import script from "./myCustomerReport.vue?vue&type=script&lang=js&"
export * from "./myCustomerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports